import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { makeRequest } from "../apis/makeRequest";
import { getProduct, getValidarCarga } from "../apis/backendRequests";
import { Grid, Button, Box, useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ProductCard from "../components/Catalogo/ProductCardCatalogo";
import TableUnitCatalogo from "../components/Catalogo/TableUnitCatalogo";
import PopUp from "../components/PopUp";
import Breadcrumb from "../components/Breadcrumb";
import { cartActions, notificationActions } from "../actions";
import { trackAddToCart } from "../helpers/analytics";
import { trackAddToCartMeta } from "../helpers/meta";


export default function CatalogoDetails({ isClient }) {
  const { productId } = useParams();
  const { items } = useSelector((state) => state.cart);
  const { isLoggedIn, dynamicsId } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  const [product, setProduct] = useState({});
  const [unit, setUnit] = useState();
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");

  const styles = {
    breadCrumb: {
      fontSize: "14px",
      marginBottom: "10px",
    },
    link: {
      fontSize: "14px",
      cursor: "pointer",
    },
    boxTop: {
      display: "flex",
      flexDirection: "column",
      justifyCOntent: "center",
      marginBottom: "30px",
      marginTop: "10px",
      gap: "10px"
    },
    buttonVolver: {
      width: "18%",
      fontSize: "12px",
      color: "black",
      borderColor: "grey",
    },
    buttonVolverMobile: {
      width: "90%",
      fontSize: "12px",
      color: "black",
      borderColor: "grey",
    },
    gridItems: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center"
    },
    gridItemsMobile: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alingItems: "center"
    }
  };

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    if (!productId) return;

    makeRequest(
      () => getProduct(productId, isLoggedIn ? dynamicsId : "online"),
      (res) => setProduct(res.data),
      null,
      { checkEmptyResults: false }
    );
  }, [productId, dynamicsId]);



  const checkCarga = () => {
    const value = unit;
    const validate = value.toString().charAt(0);
    if (validate === "0" && value.length > 1) {
      setMsg("Valor ingresado de manera erronea, por favor intente de nuevo");
      setShowMsg(true);
      return;
    }
    makeRequest(
      () => getValidarCarga(productId, unit),
      (res) => {
        if (res.data.leyenda === "ok") {
          submit();
        } else {
          setMsg(res.data.leyenda);
          return setShowMsg(true);
        }
      }
    );
  };

  const submit = () => {
    const existItem = items.find((obj) => obj.productId === productId);
    if (existItem) {
      const unitCheck = unit;
      const i = items.indexOf(existItem);
      if (!location.state) {
        setShowMsg(true);
        return setMsg(
          "Producto ya añadido, si desea editar o añadir cantidad, dirijase al sector del carrito"
        );
      }
      makeRequest(
        () => getValidarCarga(productId, unitCheck),
        (res) => {
          if (res.data.leyenda === "ok") {
            trackAddToCart(product,unitCheck)
            trackAddToCartMeta(product,unitCheck)
            dispatch(
              cartActions.editItem(i, {
                ...product,
                ["quantity"]: unitCheck,
              })
            );
            dispatch(
              notificationActions.showSuccess({
                message: "Se han editado los productos seleccionados",
              })
            );
            return location.state !== "" ? navigate("/cart") : navigate("/products");
          } else {
            setShowMsg(true);
            setMsg(res.data.leyenda);
            return;
          }
        }
      );
    } else {
      trackAddToCart(product,unit)
      trackAddToCartMeta(product,unit)
      dispatch(
        cartActions.addItem({
          ...product,
          quantity: unit,
        })
      );
      dispatch(
        notificationActions.showSuccess({
          message: "Se han agregado los productos seleccionados",
        })
      );
      return navigate("/products");
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Box marginLeft={"5%"} style={styles.boxTop} >
        <Breadcrumb
          prodCategoria={product.categoriaDescription}
          prodRubro={product.rubroDescription}
          prodSubRubro={product.subRubroDescription}
        />
        {location.state && (
          <Button
            size="small"
            style={mobile ? styles.buttonVolverMobile : styles.buttonVolver}
            variant="outlined"
            startIcon={<ChevronLeftIcon />}
            onClick={() => {
              navigate("/cart");
            }}
          >
            Volver al carrito
          </Button>
        )}
      </Box>
      <Grid container style={mobile ? styles.gridItemsMobile : styles.gridItems} spacing={2} >
        <Grid item sm={12} md={12} lg={6} xl={6} >
          {typeof product.productId !== "undefined" && (
            <ProductCard product={product} productDetail={true} />
          )}
        </Grid>
        <Grid item sm={12} md={12} lg={4} xl={4}>
          <TableUnitCatalogo
            product={product}
            setterUnit={setUnit}
            isEdit={location.state}
            submit={checkCarga}
            isClient={isClient}
          />
        </Grid>
        <PopUp open={showMsg} setClose={setShowMsg} msg={msg} />
      </Grid>
    </>
  );
}
